import axios from "../http";

class WarehouseManage {
  //仓库列表
  getWarehouseList(name) {
    const url = `/oa/api/warehouse/list?name=${name}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增仓库
  postAddWarehouse(data) {
    const url = `/oa/api/warehouse/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //编辑仓库
  postUpdateWarehouse(data) {
    const url = `/oa/api/warehouse/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //详情
  postDetailsWarehouse(id) {
    const url = `/oa/api/warehouse/detail?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 保存仓库映射
  postSaveMappingWarehouseList(data) {
    const url = `/oa/api/warehouse/relate/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除仓库映射
  postDelMappingWarehouseList(id) {
    const url = `/oa/api/warehouse/relate/delete/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 仓库映射列表
  getMappingWarehouseList() {
    const url = `/oa/api/warehouse/relate/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default WarehouseManage;
